import React, { useEffect, useState } from "react"

import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch from "@material-ui/core/Switch"
import Typography from "@material-ui/core/Typography"

import {
    obterConfiguracaoFechamento,
    salvarConfiguracaoFechamento,
} from "../../../services/historicoCaixa"
import { useSnackbar } from "../../../utils/notificacoes"

/**
 * Opções da impressão do fechamento de caixa, configuradas pela própria loja na tela do Caixa.
 * "Imprimir itens vendidos": inclui no "Imprimir Fechamento" a lista de produtos e adicionais
 * vendidos no caixa (parâmetro IMPRIMIR_ITENS_FECHAMENTO_CAIXA no backend).
 */
export default function ConfiguracaoFechamento({ idEstabelecimento }) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()
    const [imprimirItensVendidos, setImprimirItensVendidos] = useState(false)
    const [carregando, setCarregando] = useState(true)

    useEffect(() => {
        if (!idEstabelecimento) return
        let ativo = true
        setCarregando(true)
        obterConfiguracaoFechamento(autorizacao, idEstabelecimento).then(resp => {
            if (!ativo) return
            if (!resp?.retornoErro) {
                setImprimirItensVendidos(!!resp.imprimirItensVendidos)
            }
            setCarregando(false)
        })
        return () => {
            ativo = false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idEstabelecimento])

    const alterar = async event => {
        const novoValor = event.target.checked
        setImprimirItensVendidos(novoValor)
        setCarregando(true)
        const resp = await salvarConfiguracaoFechamento(
            autorizacao,
            { imprimirItensVendidos: novoValor },
            idEstabelecimento
        )
        setCarregando(false)
        if (resp?.retornoErro) {
            setImprimirItensVendidos(!novoValor)
            enqueueSnackbar(resp.mensagem || "Não foi possível salvar a configuração.", {
                variant: "error",
            })
            return
        }
        enqueueSnackbar(
            novoValor
                ? "O fechamento passará a imprimir os itens vendidos."
                : "O fechamento não imprimirá mais os itens vendidos.",
            { variant: "success" }
        )
    }

    return (
        <div style={{ textAlign: "center" }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={imprimirItensVendidos}
                        onChange={alterar}
                        disabled={carregando}
                    />
                }
                label="Imprimir itens vendidos no fechamento"
            />
            <Typography variant="caption" display="block" color="textSecondary">
                Lista os produtos e adicionais vendidos no caixa ao final do "Imprimir Fechamento".
            </Typography>
        </div>
    )
}
